import {
    establishUserStats,
    establishUserStatsFailure,
    establishUserStatsSuccess,
} from 'redux/actions/organizationUserStats';
import apiRoutes from 'config/apiRoutes';

const establishOrganizationUserStatsThunk = (
    getAccessTokenSilently,
    logout,
    userId
) => (dispatch) => {
    dispatch(establishUserStats());

    return getAccessTokenSilently()
        .then((token) => {
            fetch(apiRoutes.get.organizationUserStats(userId), {
                method: 'GET',
                headers: {
                    organization_slug: window.localStorage.getItem(
                        'MP_ORGANIZATION'
                    ),
                    Authorization: `Token token="${token}"`,
                },
            })
                .then((res) => res.json())
                .then((res) => {
                    if (res.error) {
                        return dispatch(establishUserStatsFailure(res.error));
                    }

                    return dispatch(establishUserStatsSuccess(res));
                })
                .catch((err) =>
                    dispatch(
                        establishUserStatsFailure({
                            err,
                        })
                    )
                );
        })
        .catch(() => logout({ returnTo: window.location.origin }));
};

export default establishOrganizationUserStatsThunk;
